import React from "react";
import PopUp from "../PopUp";

const Home = () => {
  return (
    <>
      <PopUp />
    </>
  );
};

export default Home;
